import { InputSize } from "./Input.types";

export const INPUT_SIZE_CLASSES: Record<InputSize, string> = {
  sm: "min-h-8 px-3 py-1.5 text-xs",
  md: "min-h-10 px-3 py-2 text-sm",
  lg: "min-h-12 px-3.5 py-2.5 text-sm",
} as const;
